import '../../../shared/services/authConfig';
import { signIn, type SignInInput, type SignInOutput } from 'aws-amplify/auth';
import { IS_LOCAL_FLOCI } from '../../../shared/utils/localFloci';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginResult {
  success: boolean;
  data?: SignInOutput;
  error?: string;
}

export const authLogin = async (
  credentials: LoginCredentials
): Promise<LoginResult> => {
  try {
    // Floci has no SRP, so `--mode floci` skips the password step (OTP only).
    // Amplify rejects a password with CUSTOM_WITHOUT_SRP, so it is omitted.
    const isFloci = IS_LOCAL_FLOCI;
    const username = credentials.email.trim().toLowerCase();
    const signInInput: SignInInput = isFloci
      ? { username, options: { authFlowType: 'CUSTOM_WITHOUT_SRP' } }
      : {
          username,
          password: credentials.password,
          options: { authFlowType: 'CUSTOM_WITH_SRP' },
        };

    // const result = await signOut()

    const result = await signIn(signInInput);

    return {
      success: true,
      data: result,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Wystąpił błąd podczas logowania';

    // Check for deactivated user error (PreAuthentication trigger)
    if (
      errorMessage.includes('disabled') ||
      errorMessage.includes('PreAuthentication failed') ||
      errorMessage.includes('User account is disabled')
    ) {
      return {
        success: false,
        error: 'ACCOUNT_DEACTIVATED',
      };
    }

    // Check for unpaid client error (PreAuthentication trigger)
    if (errorMessage.includes('payment')) {
      return {
        success: false,
        error: 'PAYMENT_PENDING',
      };
    }

    return {
      success: false,
      error: errorMessage,
    };
  }
};
